import { render, staticRenderFns } from "./PublicationHistoryElement.vue?vue&type=template&id=670cfcb4&scoped=true&"
import script from "./PublicationHistoryElement.vue?vue&type=script&lang=js&"
export * from "./PublicationHistoryElement.vue?vue&type=script&lang=js&"
import style0 from "./PublicationHistoryElement.vue?vue&type=style&index=0&id=670cfcb4&lang=scss&scoped=true&"
import style1 from "./PublicationHistoryElement.vue?vue&type=style&index=1&id=670cfcb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670cfcb4",
  null
  
)

export default component.exports